/*
  Tokyo Romance Club — Newsletter & SNS scroll reveal.
  Heading, subcopy, the signup form, and each SNS icon (if any are
  configured) are observed independently via IntersectionObserver, so
  items only fade up once they individually enter the viewport. Heading
  reveals first, subcopy ~100ms later, the form ~150ms after that; SNS
  icons (if present) reveal after the form and stagger ~75ms among
  themselves. Once revealed, an element is unobserved and never
  re-hidden. Never runs inside the theme editor.
*/
(function () {
  if (window.__trcNewsletterMotionInit) return;
  window.__trcNewsletterMotionInit = true;

  var designMode = document.documentElement.classList.contains('shopify-design-mode');
  if (designMode) return;

  var reduceMotion = false;
  try {
    reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  } catch (e) {}

  var REVEAL_CLASS = 'trc-nl-in';

  function reveal(el) {
    el.classList.add(REVEAL_CLASS);
  }

  function observeGroup(targets, delayFor) {
    if (targets.length === 0) return;

    if (reduceMotion || !('IntersectionObserver' in window)) {
      targets.forEach(reveal);
      return;
    }

    var io = new IntersectionObserver(
      function (entries) {
        entries
          .filter(function (entry) {
            return entry.isIntersecting;
          })
          .forEach(function (entry, i) {
            io.unobserve(entry.target);
            window.setTimeout(function () {
              reveal(entry.target);
            }, delayFor(i));
          });
      },
      { rootMargin: '0px 0px -10% 0px', threshold: 0.15 }
    );

    targets.forEach(function (target) {
      io.observe(target);
    });
  }

  function init() {
    var section = document.querySelector('[id$="__trc_newsletter"]');
    if (!section) return;

    document.documentElement.classList.add('trc-js');

    var mainTargets = [];
    var heading = section.querySelector('[class*="__text_heading"]');
    if (heading) mainTargets.push(heading);
    var sub = section.querySelector('[class*="__text_sub"]');
    if (sub) mainTargets.push(sub);
    var form = section.querySelector('.email-signup-block');
    if (form) mainTargets.push(form);

    var mainDelays = [0, 100, 250];
    observeGroup(mainTargets, function (i) {
      return mainDelays[i] !== undefined ? mainDelays[i] : 250;
    });

    var socialTargets = Array.prototype.slice.call(section.querySelectorAll('.social-icons__icon-wrapper'));
    observeGroup(socialTargets, function (i) {
      return 300 + i * 75;
    });
  }

  if (document.readyState !== 'loading') {
    init();
  } else {
    document.addEventListener('DOMContentLoaded', init);
  }
})();
